import React, { useState } from 'react'
import {BrowserRouter, Link, Route, Routes} from 'react-router-dom'
import { auth, db } from '../firebase'
import { useAuthState } from 'react-firebase-hooks/auth'
import Entry from './Entry'
import SignIn from './SignIn'
import { addDoc, collection, doc, setDoc } from 'firebase/firestore'
import SignOut from './SignOut'
import Graph from './Graph'
import List from './List'
import { FiEdit , FiPlus } from 'react-icons/fi';
import { MdAccountCircle } from 'react-icons/md';
import { PiSignOutBold } from 'react-icons/pi';

function Home({setCurrentId,setUserTags, currentId, userTags}) {

  const [user, loading] = useAuthState(auth)
  const [showAccount, setShowAccount] = useState(false)

  const redList = [
    "enraged", "panicked", "stressed", "jittery", "shocked",
    "livid", "furious", "frustrated", "tense", "stunned",
    "fuming", "frightened", "angry", "nervous", "restless",
    "anxious", "apprehensive", "worried", "irritaed", "annoyed",
    "repulsed", "troubled", "concered", "uneasy", "peeved"
  ]

  const moodMater = []

  function makeMoodMater (list, pls, eng) {
    let pleasantnessCount = 0
    let energyCount = 0
    let pleasantness = pls
    let energy = eng

    list.array.forEach(element => {

      moodMater.push({
        name: element,
        pleasantness: pleasantness,
        energy: energy
      })

      if (pleasantness===pls+4) pleasantness = pls
      else pleasantness += 1

      if(energy===pls+4) energy = eng
      else energy += 1

    });

    moodMater.forEach((item)=>{console.log(item)})

  }

  const moodsRed = [
    {
      name: "enraged",
      pleasantness: -5,
      energy: 5
    },

    {
      name: "panicked",
      pleasantness: -4,
      energy: 5,
    },

    {
      name: "streassed",
      pleasantness: -3,
      energy: 5,
    },

    {
      name: "jittery",
      pleasantness: -2,
      energy: 5,
    },

    {
      name: "shocked",
      pleasantness: -1,
      energy: 5,
    },

    {
      name: "livid",
      pleasantness: -5,
      energy: 4,
    },

    {
      name: "furious",
      pleasantness: -4,
      energy: 4,
    },


    {
      name: "frustrated",
      pleasantness: -3,
      energy: 4,
    },

    {
      name: "tense",
      pleasantness: -2,
      energy: 4,
    },

    {
      name: "stunned",
      pleasantness: -1,
      energy: 4,
    },


    {
      name: "fuming",
      pleasantness: -5,
      energy: 3,
    },

    {
      name: "frightened",
      pleasantness: -4,
      energy: 3,
    },

    {
      name: "angry",
      pleasantness: -3,
      energy: 3,
    },

    {
      name: "nervous",
      pleasantness: -2,
      energy: 3,
    },

    {
      name: "restless",
      pleasantness: -1,
      energy: 3,
    },

    {
      name: "anxious",
      pleasantness: -5,
      energy: 2,
    },

    {
      name: "",
      pleasantness: 0,
      energy: 0,
    },

    {
      name: "",
      pleasantness: 0,
      energy: 0,
    },

    {
      name: "",
      pleasantness: 0,
      energy: 0,
    },
    {
      name: "",
      pleasantness: 0,
      energy: 0,
    },
    {
      name: "",
      pleasantness: 0,
      energy: 0,
    },
    {
      name: "",
      pleasantness: 0,
      energy: 0,
    },
    {
      name: "",
      pleasantness: 0,
      energy: 0,
    },

    {
      name: "",
      pleasantness: 0,
      energy: 0,
    },

    {
      name: "",
      pleasantness: 0,
      energy: 0,
    },

    {
      name: "",
      pleasantness: 0,
      energy: 0,
    },

    {
      name: "",
      pleasantness: 0,
      energy: 0,
    },
  ]

 
  return (
    <div className='main'>

      <div>
        {userTags.forEach((tag)=>{
          <p>{tag}</p>
        })} 
      </div>

      <List setUserTags={setUserTags} setCurrentId={setCurrentId} userTags={userTags} currentId={currentId}/>

      <div className='fixed-bottom'>
      <div className='account'>
        <SignOut/>
      </div>
      
    
    {
    /*
      <Link onClick={()=>{setCurrentId("")}} className='link' to={`/edit`}>
        <div className='btn positive'>
        + New record
        </div>
      </Link>
      */
    }
      
    
    
    </div>

    </div>
  )
}

export default Home